export function getConfig(p = {}) {

    const { config = {} } = p

    const commonConfig = config.common || {}
    const globalsConfig = config.globals || {}

    const { WAPP, DEV } = globalsConfig

    const common = {
        ...commonConfig,
        lang: 'hu_HU',
        siteName: 'Takarító munkák',
        description: 'A Takarító munkák Magyarország takarító álláshirdetési portálja. Találd meg nálunk új munkahelyed vagy új kollégád. Lakossági takarítás, épülettakarítás, szállodai és vezetői pozíciók.',
        graphql: {
            route: (DEV) ? '/graphql' : '/g' + WAPP
        }
    }

    return {
        config: {
            ...config,
            common: common
        }
    }
}
